module.exports = __webpack_public_path__ + "media/assets/texture-06d27212b41d23ba98250f020c65fd99.png";